<div class="card">
	<div class="card-header">
		<h1>Administración de la organización</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-sm-8">
				<p class="text-muted">Se mostrarán los puestos según la ubicación que elijas</p>
				<div class="input-group">
					<label for="location" class="input-group-text"><i class="fa-solid fa-map-location"></i></label>
					<select name="location" id="location" (ngModelChange)="changeSelected($event)"
						[(ngModel)]="locationSelected" class="form-select">
						<option *ngFor="let location of locations" value="{{location.id}}">{{location.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm-4" style="display: flex; justify-content: center;align-items: center;">
				<div class="input-group">
					<label for="options" class="input-group-text">CREAR</label>
					<select name="options" id="options" [(ngModel)]="typeCreate" class="form-select">
						<option value="0">AREA</option>
						<option value="1">DEPARTAMENTO</option>
						<option value="2">PUESTO</option>
						<option value="3">UBICACIÓN</option>
					</select>
					<button class="btn btn-primary" (click)="create()"><i class="fa fa-plus"></i></button>
				</div>
			</div>
		</div>
		<div id="svg-tree"></div>
	</div>
</div>
<app-modal-location *ngIf="createLocation" [isCreating]="false" (close)="createLocation = false"></app-modal-location>
<app-modal-admin-area *ngIf="tempAreaCreate" [newArea]="tempAreaCreate" [warehouses]="locations"
	[isCreating]="createArea" (close)="closingEditorArea($event)"></app-modal-admin-area>
<app-modal-question *ngIf="temporalQuestion" (close)="closeOptionModal($event, temporalQuestion['type'])"
	[options]="temporalQuestion['options']" [title]="temporalQuestion['title']"
	[question]="temporalQuestion['question']"></app-modal-question>
<app-modal-admin-position *ngIf="tempPositionEdit" [newPosition]="tempPositionEdit" [departments]="departments"
	[isCreating]="createPosition" [positions]="positions" (close)="closingEditorPosition($event)"></app-modal-admin-position>
<app-modal-admin-department *ngIf="tempDepartmentEdit" [newDepartment]="tempDepartmentEdit" [areas]="areas"
	[isCreating]="createDepartment" [positions]="positions" (close)="closingEditorDepartment($event)"></app-modal-admin-department>